<template>
  <div class="dot-indicator"
       :style="sizeStyle"
       :class="{ blink, [colorClass]: true }"/>
</template>

<script>
export default {
  name: 'DotIndicator',
  props: {
    blink: Boolean,
    color: {
      type: String,
      default: 'danger-red',
    },
    size: {
      type: Number,
      default: 8,
    },
  },
  computed: {
    colorClass() {
      return `bg-riseup-${this.color}`;
    },
    sizeStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
      };
    },
  },
};
</script>

<style scoped lang="scss">

.dot-indicator {
  border-radius: 100%;

  &.blink {
    animation: blinker 1s linear;
    animation-iteration-count: 3;
  }

  @keyframes blinker {
    50% {
      opacity: 0;
      transform: scale(0.5);
    }
  }
}

</style>
